import React from 'react';
import { Text } from '@ydistri/ds';
import { formatPercentage } from '@ydistri/generic-utils';
import { Tag, Tooltip } from 'antd';
import { styled } from 'styled-components';

const ExecuteRate = styled(Tag)`
  background-color: #bfe8ca;
  color: #14532d;
`;

interface RateTagProps {
  value?: number | null;
  title?: string;
}

/**
 * Displays a rate as a tag with a percentage value.
 * @param value
 * @param title
 * @constructor
 */
const RateTag: React.FC<RateTagProps> = ({ value, title }) => {
  if (value === null || value === undefined) return null;

  const tag = (
    <ExecuteRate bordered={false}>
      <Text $bold>{formatPercentage(value * 100)}</Text>
    </ExecuteRate>
  );
  return title ? <Tooltip title={title}>{tag}</Tooltip> : tag;
};

export default RateTag;
